import { Tabs } from "antd";
import PropTypes from "prop-types";
import React from "react";

import { ThemeContext } from "../../layouts";

import Computer from "./Computer";
import Devices from "./Devices";
import Laptop from "./Laptop";
import Gaming from "./Gaming";

const TabPane = Tabs.TabPane;

function callback(key) {
  console.log(key);
}

const Tools = props => {
  return (
    <React.Fragment>
      <div className="tools">
        <ThemeContext.Consumer>
          {theme => (
            <Tabs defaultActiveKey="1" onChange={callback} size="large">
              <TabPane tab="Computer" key="1">
                <Computer />
              </TabPane>
              <TabPane tab="Devices" key="2">
                <Devices />
              </TabPane>
              <TabPane tab="Laptop" key="3">
                <Laptop />
              </TabPane>
              <TabPane tab="Gaming" key="4">
                <Gaming />
              </TabPane>
            </Tabs>
          )}
        </ThemeContext.Consumer>
      </div>
    </React.Fragment>
  );
};

Tools.propTypes = {
  form: PropTypes.object
};

export default Tools;



// WEBPACK FOOTER //
// ./src/components/Tools/Tools.js